export default {
  hero: {
    title: "من که هستم؟",
    greeting: "سلام، جواد هستم — مدیر فنی و رهبر تیم، مسئول مهندسی سرتاسری محصول از سخت‌افزار تا نرم‌افزار.",
    intro:
      "سخت‌افزار طراحی و ساخته‌ام و این تجربه را به رهبری توسعه سرتاسری نرم‌افزار، از معماری تا استقرار، گسترش داده‌ام. به‌عنوان مدیر فنی و رهبر تیم، محصولات را از ابتدا تا انتها هدایت می‌کنم — از ایده‌های اولیه سخت‌افزاری تا نرم‌افزارهای وب، موبایل و دسکتاپ عرضه‌شده — و در هر انتشار، نظم دواپس و مدیریت پروژه عملی را به کار می‌گیرم.",
  },
  connect: {
    title: "با من در ارتباط باشید",
    subtitle: "بیایید با هم چیز شگفت‌انگیزی بسازیم! از طریق هرکدام از این پلتفرم‌ها در تماس باشید.",
  },
  socialAriaLabel: "{{label}} جواد",
  socialLabels: {
    email: "ایمیل",
    website: "وب‌سایت",
    linkedin: "لینکدین",
    github: "گیت‌هاب",
    telegram: "تلگرام",
    instagram: "اینستاگرام",
    youtube: "یوتیوب",
    twitter: "توییتر",
    facebook: "فیسبوک",
  },
};
